import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const STATS = [
  {
    number: "850M+",
    label: "People Affected Globally",
    description: "More than 10% of world population has kidney disease",
    color: "red"
  },
  {
    number: "138M",
    label: "Cases in India",
    description: "2nd highest in the world after China",
    color: "orange"
  },
  {
    number: "1.48M",
    label: "Deaths Per Year",
    description: "CKD is 9th leading cause of death worldwide",
    color: "red"
  },
  {
    number: "90%",
    label: "Don't Know They Have It",
    description: "Kidney disease shows NO symptoms until last stage",
    color: "orange"
  }
];

export const ShockingStats = () => (
  <section data-testid="stats-section" className="relative py-16 md:py-20 overflow-hidden">
    <div className="absolute inset-0 bg-gradient-to-b from-red-50 via-white to-white" />

    <div className="relative max-w-7xl mx-auto px-6 md:px-12">
      <div className="text-center mb-10">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-100 border border-red-200 mb-4">
          <span className="text-red-500 text-lg">⚠️</span>
          <span className="text-red-600 font-semibold">Silent Killer Alert</span>
        </div>
        <h2 className="font-display text-2xl md:text-4xl font-bold text-slate-800 mb-3">
          The <span className="text-red-600">Shocking Truth</span> About Kidney Disease
        </h2>
        <p className="text-slate-600 max-w-2xl mx-auto">
          Kidney disease is called the "Silent Killer" - it shows <span className="text-red-600 font-semibold">NO symptoms</span> until
          90% of kidney function is lost. By then, it's often too late.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-10">
        {STATS.map((stat) => (
          <div
            key={stat.label}
            data-testid={`stat-card-${stat.label.toLowerCase().replace(/\s/g, '-')}`}
            className={`relative rounded-2xl p-5 md:p-6 text-center overflow-hidden ${
              stat.color === 'red'
                ? 'bg-red-50 border border-red-200'
                : 'bg-orange-50 border border-orange-200'
            }`}
          >
            <p className={`font-display text-3xl md:text-4xl font-bold mb-1 ${
              stat.color === 'red' ? 'text-red-600' : 'text-orange-600'
            }`}>
              {stat.number}
            </p>
            <p className="text-slate-800 font-semibold text-sm mb-1">{stat.label}</p>
            <p className="text-slate-500 text-xs">{stat.description}</p>
          </div>
        ))}
      </div>

      <div className="bg-white rounded-2xl p-6 md:p-8 border border-red-200 shadow-sm max-w-3xl mx-auto text-center">
        <p className="text-lg md:text-xl text-slate-700 mb-4">
          <span className="text-red-600 font-bold">Every 10 minutes</span>, someone in India starts dialysis.
          <span className="text-red-600 font-bold"> Every year</span>, lakhs of Indians discover they have kidney failure -
          <span className="text-amber-600 font-semibold"> when it's already too late.</span>
        </p>
        <p className="text-slate-600 mb-6">
          Early detection can <span className="text-emerald-600 font-semibold">prevent 80% of kidney failures</span>.
          Don't wait for symptoms - there won't be any.
        </p>
        <a href="#signup" className="block sm:inline-block">
          <Button
            data-testid="stats-cta-button"
            size="lg"
            className="bg-red-500 hover:bg-red-600 text-slate-800 font-semibold w-full sm:w-auto px-4 sm:px-8 h-auto py-3 whitespace-normal"
          >
            <span>Protect Yourself - Get KidneyCheQ</span>
            <ArrowRight className="ml-2 w-5 h-5 flex-shrink-0" />
          </Button>
        </a>
      </div>
    </div>
  </section>
);
